import { render } from "./AllocationContentHeader.vue?vue&type=template&id=2ff2168c&scoped=true"
import script from "./AllocationContentHeader.vue?vue&type=script&lang=js"
export * from "./AllocationContentHeader.vue?vue&type=script&lang=js"

import "./AllocationContentHeader.vue?vue&type=style&index=0&id=2ff2168c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff2168c"],['__file',"src/components/budget/AllocationContentHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ff2168c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ff2168c', __exports__)) {
    api.reload('2ff2168c', __exports__)
  }
  
  module.hot.accept("./AllocationContentHeader.vue?vue&type=template&id=2ff2168c&scoped=true", () => {
    api.rerender('2ff2168c', render)
  })

}


export default __exports__